import styled, { css } from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const CardHeader = styled(Card.Header)<StyleProps>`
  padding: 24px 32px;
  ${props => props.theme.media.xsmall`
    padding: 24px 24px;
  `};

  svg {
    transition: transform 0.1s;

    ${props =>
      props.accordionIsOpen
        ? css`
            transform: rotate(180deg);
          `
        : null}
  }
`;
